import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import navguard from '@/navguard';

Vue.use(VueRouter)

const routes = [
  /**
   * Global routes
   */
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta : {
      type : ['admin', 'manager', 'driver']
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile.vue'),
    meta : {
      type : ['admin', 'manager', 'driver']
    },
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: () => import('../views/changepassword.vue'),
    meta : {
      type : ['admin', 'manager', 'driver']
    },
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: () => import('../views/login.vue'),
    meta : {
      type : ['admin', 'manager', 'driver']
    },
  },
  {
    path: '/password/reset/:uid',
    name: 'resetpassword',
    component: () => import('../views/login.vue'),
    meta : {
      type : ['admin', 'manager', 'driver']
    },
  },
  /**
   * Admin routes
   * (type) from meta will be user role allowed to access
   */
  {
    path: '/',
    name: 'deliveries',
    meta : {
      type : ['admin', 'manager']
    },
    component: () => import('../views/admin/deliveries.vue')
  },
  {
    path: '/boxes',
    name: 'boxes',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/boxes.vue')
  },
  {
    path: '/createbox',
    name: 'createbox',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/createbox.vue')
  },
  {
    path: '/editbox/:boxid',
    name: 'editbox',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/createbox.vue')
  },
  {
    path: '/flavors',
    name: 'flavors',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/flavors.vue')
  },
  {
    path: '/createflavor',
    name: 'createflavor',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/createflavor.vue')
  },
  {
    path: '/editflavor/:flavorid',
    name: 'editflavor',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/createflavor.vue')
  },
  {
    path: '/employee',
    name: 'employee',
    meta : {
      type : ['admin', 'manager']
    },
    component: () => import('../views/admin/employees.vue')
  },
  {
    path: '/newemployee',
    name: 'newemployee',
    meta : {
      type : ['admin', 'manager']
    },
    component: () => import('../views/admin/newemployee.vue')
  },
  {
    path: '/editemployee/:emid',
    name: 'editemployee',
    meta : {
      type : ['admin', 'manager']
    },
    component: () => import('../views/admin/newemployee.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/settings.vue')
  },
  {
    path: '/newsetting',
    name: 'newsetting',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/newsetting.vue')
  },
  {
    path: '/editsetting/:settingid',
    name: 'editsetting',
    meta : {
      type : ['admin']
    },
    component: () => import('../views/admin/newsetting.vue')
  },
  /**
   * Driver routes
   */
  {
    path: '/emdeliveries',
    name: 'employeeDeliveries',
    meta : {
      type : ['driver']
    },
    component: () => import('../views/employee/deliveries.vue')
  },
  {
    path: '/order/:id',
    name: 'order',
    meta : {
      type : ['driver']
    },
    component: () => import('../views/employee/orderDetail.vue')
  },
  {
    path: '/deliveryproof/:id',
    name: 'deliveryproof',
    meta : {
      type : ['driver']
    },
    component: () => import('../views/employee/deliveryProof.vue')
  }
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//NAVIGATION GUARD CHECKER
router.beforeEach( async (to, from, next) => {
  return navguard({to, from, next, store});
});


export default router
